<script>
    import { onMount } from "svelte";


    export let value = "low";

    function toggle(new_value) {
        return () => {
            value = new_value
        }
    }

    onMount(() => {
        if (value == undefined) {
            value = "low";
        }
    })
</script>

<div class="buttons is-fullwidth has-addons">
    <span class="button is-success {value == "low" ? "is-selected" : "is-light"}" on:click={toggle("low")}>
        Low
    </span>
    <span class="button is-warning {value == "medium" ? "is-selected" : "is-light"}" on:click={toggle("medium")}>
        Medium
    </span>
    <span class="button is-danger {value == "high" ? "is-selected" : "is-light"}" on:click={toggle("high")}>
        High
    </span>
    <span class="button {value == "na" ? "is-dark" : "is-light"}" on:click={toggle("na")}>
        N/A
    </span>
</div>

<style>
    .buttons.is-fullwidth {
        width: 100%;
    }

    .buttons.is-fullwidth .button {
        flex-grow:  1;
    }

    /*
    .buttons.is-fullwidth .button.is-outlined {
        background-color: black;
    }

    .buttons.is-fullwidth .button.is-outlined:hover {
        color: white;
    }
    */
</style>